module.exports = "<div class=\"text-center mt-3 mb-2\">\r\n    Cargando ...\r\n    <div class=\"spinner-border\" role=\"status\">\r\n        <span class=\"sr-only\">Loading...</span>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/partials/ajax-loding/ajax-loading.component.html
// module id = ./src/app/components/partials/ajax-loding/ajax-loading.component.html
// module chunks = main